import { TCreateCredentialsAction, CreateCredentialsActionTypes } from './createCredentialsActions';
import { ICreateCredentialsState } from './createCredentialsContext';

export const createCredentialsReducer = (
	state: ICreateCredentialsState,
	action: TCreateCredentialsAction,
): ICreateCredentialsState => {
	switch (action.type) {
		case CreateCredentialsActionTypes.CHANGE_CREDENTIAL_NAME:
			return {
				...state,
				credentialName: action.payload.credentialName,
			};
		case CreateCredentialsActionTypes.CHANGE_API_KEY:
			return {
				...state,
				apiKey: action.payload.apiKey,
			};
		case CreateCredentialsActionTypes.CHANGE_API_SECRET:
			return {
				...state,
				apiSecret: action.payload.apiSecret,
			};
		case CreateCredentialsActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateCredentialsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateCredentialsActionTypes.RESET_FIELDS:
			return {
				...state,
				credentialName: '',
				apiKey: '',
				apiSecret: '',
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
